import React, { FC } from 'react';

import { ImageProps } from 'app/components/image';
import { HouseType } from 'app/pages/order/model/house-type';
import { TabLabel } from 'app/components/tabs';
import { i18n } from 'app/i18n';

interface Props {
    image: ImageProps;
    houseType: HouseType;
}

export const ProductDetailsPageTabLabel: FC<Props> = (props) => {
    const { image, houseType } = props;

    return (
        <TabLabel
            image={image}
            title={i18n.page.productDetails.tabs.title[houseType]}
            description={i18n.page.productDetails.tabs.houseSize[houseType]}
        />
    );
};
